import { render, staticRenderFns } from "./BatchUpload.vue?vue&type=template&id=d4d018aa&scoped=true&"
import script from "./BatchUpload.vue?vue&type=script&lang=js&"
export * from "./BatchUpload.vue?vue&type=script&lang=js&"
import style0 from "./BatchUpload.vue?vue&type=style&index=0&id=d4d018aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d018aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4d018aa')) {
      api.createRecord('d4d018aa', component.options)
    } else {
      api.reload('d4d018aa', component.options)
    }
    module.hot.accept("./BatchUpload.vue?vue&type=template&id=d4d018aa&scoped=true&", function () {
      api.rerender('d4d018aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BatchImport/BatchUpload.vue"
export default component.exports